import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text/Text'
import { ICommonBonus } from 'config/types/bonus'
import React from 'react'
import { Trans } from 'react-i18next'
import { formatDisplayDate } from 'utils/dateHelper'
import { useDisplayBonusName } from 'views/BonusCenter/hooks'

interface InfoSectionDetailsProps {
  bonus: ICommonBonus
}

const InfoSectionDetails: React.FC<InfoSectionDetailsProps> = ({ bonus }) => {
  const [name] = useDisplayBonusName(bonus.info?.name)
  return (
    <Box>
      <Text fontSize="16px" fontWeight="600" mb="4px" color="textTeriary">
        {name}
      </Text>
      <Flex>
        <Text color="textSubtle" fontSize="12px" fontWeight="500">
          <Trans>Valid until</Trans>:
        </Text>
        <Text color="textSubtle" fontSize="12px" fontWeight="500" ml="4px">
          {formatDisplayDate(new Date(bonus.condition.expiryDate))}
        </Text>
      </Flex>
    </Box>
  )
}

export default InfoSectionDetails
